// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"11e9dd44","53":"b2cb59f2","244":"8be30202","453":"f7fcba0e","875":"b7bd0c71","965":"ef5d9aae"}[chunkId] + ".chunk.js";
};